/**
 * What the about page tells search engines and link previews — ONE copy, read by today's page
 * (src/pages/About.tsx) and its rebuild in the new design (src/design/pavilion/pages/about/), the same way
 * src/config/homeSeo.ts serves both home pages (PV4, design record §7b).
 *
 * THE SHAPE IS READ BY THE GUEST CHAT'S KNOWLEDGE SOURCE (scripts/generate-guest-knowledge-source.mjs lists this
 * file for "/about"): its extractor takes a `title:` / `description:` field whose string sits on the same line, so
 * each stays one line. The structured data keeps its JSON-style quoted keys, which the extractor does not read.
 */
import { PREST0_ORGANIZATION_REF } from './shellStructuredData';

export const ABOUT_STRUCTURED_DATA = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "About prest0",
  "description": "Learn about prest0, our mission, vision, and the team of experts behind our innovative AI platform.",
  "url": "https://prest0.ai/about",
  // the company this page is about: the shell's one Organization, pointed to (src/config/shellStructuredData.ts)
  "mainEntity": PREST0_ORGANIZATION_REF,
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://prest0.ai/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "About",
        "item": "https://prest0.ai/about"
      }
    ]
  }
} as const;

/** Where search files the about page, whichever address served it. */
export const ABOUT_CANONICAL_URL = 'https://prest0.ai/about';

/** The props both about pages hand to <SeoHead>. */
export const ABOUT_SEO = {
  title: 'About prest0 | AI Employees for Law & Finance',
  tabTitle: 'about',
  description: 'Learn about prest0 — the platform building 24/7 AI employees for law and finance teams.',
  keywords: 'about prest0, AI employees, law, finance',
  canonicalUrl: ABOUT_CANONICAL_URL,
  structuredData: ABOUT_STRUCTURED_DATA,
} as const;
